var React = require('react');

function IcAddComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-add"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M9.4165 15.8991V10.8991H4.4165V9.73242H9.4165V4.73242H10.5832V9.73242H15.5832V10.8991H10.5832V15.8991H9.4165Z","fill":"white"})));
}

IcAddComponent.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IcAddComponent;

IcAddComponent.default = IcAddComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/ResultTarifMobileV2/images/ic-add.component.svg
// module id = 1645
// module chunks = 0